module.exports = __webpack_public_path__ + "static/img/9.35d6a15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/detail/dhw/9.jpg
// module id = GFc6
// module chunks = 1